// Mixins
//Scss
import './card.scss';
// Template and media files
import template from './card.vhtml';

export default {
	template: template,
	props: {
		link: {
			type: String,
			default: '',
		},
		img: {
			default: '',
		},
		title: {
			type: String,
			default: '',
		},
		desc: {
			type: String,
			default: '',
		},
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/card/card.js